import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '@app/core/services';

@Component({
	selector: 'sb-unauthorized',
	templateUrl: './unauthorized.component.html',
	styleUrls: ['./unauthorized.component.less'],
	standalone: true,
	imports: [MatButtonModule],
})
export class UnauthorizedComponent {
	readonly title = 'Access Denied';
	readonly message = 'You are not authorized to view this unit.';

	constructor(
		private readonly authService: AuthService,
	) {
		this.authService.reset();
	}

	returnToLogin(): void {
		this.authService.forceLogout();
	}
}
